module.exports = __webpack_public_path__ + "toGroom-we-r-g.50f227d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-r-g.jpg
// module id = DWdE
// module chunks = 0